import { render, staticRenderFns } from "./IncomeByTransferItem.vue?vue&type=template&id=552bac1f&lang=pug&"
import script from "./IncomeByTransferItem.vue?vue&type=script&lang=ts&"
export * from "./IncomeByTransferItem.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeByTransferItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports